export const capitalize = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1);

export const hexToCssRgbVarVal = (hex: string) => {
    const r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    return `${r}, ${g}, ${b}`;
};
